import {
  FETCH_SYSTEM_TRANSACTION_END,
  FETCH_SYSTEM_TRANSACTION_START,
  SAVE_STATS,
  SAVE_STATS_START,
  SAVE_SYSTEM_TRANSACTION,
  SAVE_SYSTEM_TRANSACTION_PAGE,
  SAVE_SYSTEM_TRANSACTION_START
} from "appRedux/constants";

const INIT_STATE = {
  loading: false,
  transactions: [],
  loading_stats: false,
  stats: [],
  transactionPages: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SYSTEM_TRANSACTION_START: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_SYSTEM_TRANSACTION_END: {
      return {
        ...state,
        loading: false
      };
    }
    case SAVE_SYSTEM_TRANSACTION_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_SYSTEM_TRANSACTION: {
      return {
        ...state,
        loading: false,
        transactions: action
      };
    }
    case SAVE_STATS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_STATS: {
      return {
        ...state,
        loading: false,
        stats: action.payload
      };
    }
    case SAVE_SYSTEM_TRANSACTION_PAGE: {
      return {
        ...state,
        loading: false,
        transactionPages: action
      };
    }
    default:
      return state;
  }
};
